import { omitBy } from "lodash";
import { isNull, isUndefined } from "util";

export function removeEmptyProps(obj: object): object {
  return omitBy(obj, (p: string) => isUndefined(p) || isNull(p) || p === "");
}
